import { render, staticRenderFns } from "./ViewCustomersCommunications.vue?vue&type=template&id=71aa94ac&scoped=true&lang=pug&"
import script from "./ViewCustomersCommunications.vue?vue&type=script&lang=js&"
export * from "./ViewCustomersCommunications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aa94ac",
  null
  
)

export default component.exports